<template>
  <PageTemplate :top-empty-row="false" :bottom-empty-row="false" class="footer-row">
    <div class="footer-row-wrapper">
      <el-row :gutter="0">
        <div class="center">
          <span>关于我们</span>
          <el-divider direction="vertical"></el-divider>
          <span>联系我们</span>
        </div>
      </el-row>
      <WhiteSpace :size="20"></WhiteSpace>
      <WhiteSpace :size="10"></WhiteSpace>
      <el-row :gutter="0">
        <el-col>
          <div class="center copyright"><a class="records" href="http://beian.miit.gov.cn" target="_blank">粤ICP备11047554号</a>&nbsp;&nbsp;2011-2023 ©广州诺图计算机科技有限公司 版权所有</div>
        </el-col>
      </el-row>
    </div>
  </PageTemplate>
</template>

<script>
import PageTemplate from '@/components/PageTemplate'
import WhiteSpace from '@/components/WhiteSpace'
export default {
  components: {PageTemplate, WhiteSpace}
}
</script>

<style lang="scss">
.footer-row {
  background-color: #333333;
  padding: 40px 0px;
  .footer-row-wrapper {
    .center {
      color: #FFF;
      text-align: center;
    }
    .copyright {
      color: rgba(255,255,255,0.50);
    }
    .records {
      color: rgba(255,255,255,0.50);
      &:hover {
        color: #FFF;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue